import axios from 'axios';

import { DeploymentEcosystemAPIDomains } from '@dor/infra';
import { EnvironmentContext } from '@dor/lib';

import { TRACKING_TOKEN_IDS } from './consts.ts';
import { ITokenPrice, ITokenPrices } from './types.ts';

const EcosystemAPI = axios.create({
  baseURL: 'https://' + DeploymentEcosystemAPIDomains[EnvironmentContext.stage]
});

const fetchTokenPrices = async () => {
  const tokenPrices: ITokenPrices = {};

  try {
    const { data } = await EcosystemAPI.get<{
      data: Record<string, ITokenPrice>;
    }>('/coin-prices', {
      params: {
        ids: Object.values(TRACKING_TOKEN_IDS).join(','),
        vs_currencies: 'usd',
        include_market_cap: true,
        include_24hr_vol: true,
        include_24hr_change: true,
        include_last_updated_at: true,
        token: 'lattice'
      }
    });

    for (const [key, tokenId] of Object.entries(TRACKING_TOKEN_IDS) as [
      keyof typeof TRACKING_TOKEN_IDS,
      (typeof TRACKING_TOKEN_IDS)[keyof typeof TRACKING_TOKEN_IDS]
    ][]) {
      tokenPrices[key] = data.data[tokenId];
    }
  } catch (e) {
    console.error('Error fetching token prices', e);
  }
  return tokenPrices;
};

export { fetchTokenPrices };
